import { selectClasses, inputClasses, EcommerceSelect } from './ecommerce-select';
export default EcommerceSelect;
export { selectClasses, inputClasses };